import { Check, Loader2 } from 'lucide-react';
import { useNewsletterEnabled, useNewsletterSubscribe } from '@/lib/newsletter';

// Inline footer subscribe form. Self-hides when the ListMonk integration is
// disabled server-side. Styled for the dark footer surface. Shares submit logic
// with the floating NewsletterNudge via useNewsletterSubscribe.
export function FooterNewsletter() {
  const enabled = useNewsletterEnabled();
  const { email, setEmail, state, error, setError, submit } = useNewsletterSubscribe('footer');

  if (!enabled) return null;

  const submitting = state === 'submitting';
  const success = state === 'success';

  return (
    <div className="pt-4">
      <h4 className="text-xs font-geist-mono uppercase tracking-widest text-white/55 mb-3">
        Newsletter
      </h4>
      {success ? (
        <p className="inline-flex items-center gap-2 text-sm text-white/80">
          <Check className="w-4 h-4" aria-hidden="true" />
          You&rsquo;re subscribed. Thank you!
        </p>
      ) : (
        <form onSubmit={submit} noValidate className="max-w-xs">
          <p className="text-sm text-white/60 mb-3 leading-relaxed">
            New writing, straight to your inbox. No spam.
          </p>
          <div className="flex flex-col gap-2 sm:flex-row">
            <label htmlFor="footer-newsletter-email" className="sr-only">
              Email address
            </label>
            <input
              id="footer-newsletter-email"
              name="email"
              type="email"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (error) setError(null);
              }}
              placeholder="your@email.com"
              aria-invalid={!!error}
              aria-describedby={error ? 'footer-newsletter-error' : undefined}
              className="w-full rounded-lg border border-white/20 bg-white/5 px-4 py-2.5 text-sm text-white placeholder:text-white/55 focus:border-white/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40 transition-colors"
            />
            <button
              type="submit"
              disabled={submitting}
              aria-busy={submitting}
              className="flex items-center justify-center gap-2 rounded-lg bg-white px-5 py-2.5 text-sm font-medium text-surface-dark transition-colors hover:bg-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 disabled:cursor-not-allowed disabled:opacity-60 whitespace-nowrap"
            >
              {submitting && <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />}
              {submitting ? 'Subscribing…' : 'Subscribe'}
            </button>
          </div>
          {error && (
            <p id="footer-newsletter-error" className="mt-2 text-xs text-red-400">
              {error}
            </p>
          )}
        </form>
      )}
    </div>
  );
}
